<template>
  <div class="kefu">
    <el-page-header @back="$router.back()" content="账号申诉"></el-page-header>
    <div class="main" style="margin-top: 30px;">

      <!-- type 0：登录表单 -->
      <el-form v-if="type === 0" label-width="80px">
        <p style="color: #666; margin-bottom: 16px;">请先登录要申诉的账号</p>
        <el-form-item label="账号">
          <el-input v-model="user.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="user.password" type="password" placeholder="请输入密码" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login">登录</el-button>
        </el-form-item>
      </el-form>

      <!-- type 1：封禁状态 -->
      <div v-else-if="type === 1">
        <div style="text-align: center; padding: 30px 0 10px;">
          <template v-if="active">
            <el-button type="success" icon="el-icon-check" circle></el-button>
            <p style="margin-top: 12px; font-size: 16px;">该账号是启用状态</p>
          </template>
          <template v-else>
            <el-button type="danger" icon="el-icon-close" circle></el-button>
            <p style="margin-top: 12px; font-size: 16px; color: #f56c6c;">您的账号被封禁至 {{ bannedTime }}</p>
          </template>
        </div>
        <div v-if="!active && jubao.jubao_id" style="margin-top: 20px;">
          <h3 style="font-size: 16px; margin-bottom: 12px;">封禁原因</h3>
          <el-form label-width="100px" style="background: #f8f9fa; padding: 16px; border-radius: 4px;">
            <el-form-item label="举报内容">{{ jubao.jubao_content }}</el-form-item>
            <el-form-item label="违规地址">
              <a :href="jubao.jubao_url" target="_blank" style="color: #0E7490;">{{ jubao.jubao_url }}</a>
            </el-form-item>
            <el-form-item label="截图">
              <img v-for="(img, i) in jubao.jubao_img" :key="i" :src="img" style="width: 200px; margin-right: 8px;" />
            </el-form-item>
            <el-form-item label="处理结果">{{ jubao.result || '（暂无）' }}</el-form-item>
          </el-form>
          <div style="text-align: center; margin-top: 20px;">
            <el-button type="primary" @click="type = 2">去申诉</el-button>
          </div>
        </div>
      </div>

      <!-- type 2：申诉表单 -->
      <el-form v-else-if="type === 2" label-width="80px">
        <el-form-item label="申诉描述">
          <el-input type="textarea" :rows="10" v-model="form.shensu_content" placeholder="请描述你的申诉理由"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="type = 1">返回</el-button>
        </el-form-item>
      </el-form>

      <!-- type 3：成功态 -->
      <div v-else style="text-align: center; padding: 60px 0;">
        <el-button type="success" icon="el-icon-check" circle size="medium"></el-button>
        <h3 style="margin: 16px 0 8px;">添加申诉成功</h3>
        <p style="color: #999; font-size: 14px;">平台在查明后会解封您的账号</p>
        <el-button style="margin-top: 20px;" @click="$router.push('/')">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getJubaoContent, createShensu } from '@/api'

export default {
  name: 'Shensu',
  data() {
    return {
      type: 0,
      user: { username: '', password: '' },
      form: { shensu_content: '' },
      jubao: {},
      bannedTime: ''
    }
  },
  computed: {
    active() {
      return !this.jubao.jubao_id
    }
  },
  methods: {
    login() {
      if (!this.user.username || !this.user.password) {
        this.$message.error('请输入账号密码')
        return
      }
      login({ username: this.user.username, password: this.user.password, type: 'shensu' }).then((res) => {
        if (res.state.type !== 'SUCCESS') {
          this.$message.error('用户名或密码错误')
          return
        }
        this.type = 1
        this.bannedTime = new Date().toLocaleDateString()
        // 模拟：当前 demo 账号未被封禁，展示启用状态；输入 wangqiang 演示封禁申诉流程
        if (this.user.username === 'wangqiang') {
          this.bannedTime = '2026-12-31 23:59'
          getJubaoContent('jb1').then((r) => {
            this.jubao = r.data || {}
          })
        } else {
          this.jubao = {}
        }
      })
    },
    submit() {
      if (!this.form.shensu_content) {
        this.$message.error('请填写申诉描述')
        return
      }
      createShensu({ shensu_content: this.form.shensu_content, shensu_user: this.user.username, shensu_jubao_id: this.jubao.jubao_id || '' }).then(() => {
        this.type = 3
      })
    }
  }
}
</script>
